import Api from './api';

const UserService = {
  login: async (params) => { 
    const response = await Api.post("/user/login", params);
    if (response.data.user['role'] === 'adm') {
      sessionStorage.setItem('user', JSON.stringify(response.data.user));
      sessionStorage.setItem('token', response.data.user.token);
      return true;
    } else {
      return false;
    }
  },

  logout: () => {
    localStorage.removeItem('user', null);
    localStorage.removeItem('token', null);
    localStorage.removeItem('app', null);
    localStorage.removeItem('pdv', null);
    sessionStorage.removeItem('user', null);
    sessionStorage.removeItem('token', null);
    sessionStorage.removeItem('app', null);
    sessionStorage.removeItem('pdv', null);
  },

  register: (params) => Api.post("/adm/register", params, { headers: {'Authorization': sessionStorage.getItem('token')} }),

  activate: (params) => Api.post("/user/login", params),

  forgotPassword: (params) => Api.post("/user/forgotPassword", params),

  update: async (params) => Api.post("/adm/edit", params, { headers: {'Authorization': sessionStorage.getItem('token')} }),

}

export default UserService;
